import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)
const _import = require("./_import_" + process.env.NODE_ENV);    //根据开发环境，生产环境定义不同的_import方法

const routes = [
  // {
  //   path: '/faq/:webid/:lang/:serverid/:userid',
  //   components:require('@/pages/faq/index.vue'),
  //   meta:{
  //     title: 'FAQ',
  //     keepAlive: false
  //   }
  // },
  // {
  //   path: '/chat/:webid/:lang/:serverid/:userid',
  //   components:require('@/pages/chat/index.vue'),
  //   meta:{
  //     title: '人工客服详情页',
  //     keepAlive: false
  //   }
  // },
  // {
  //   path: '/feedback/:webid/:lang/:devecied',
  //   components:require('@/pages/feedback/index.vue'),
  //   meta:{
  //     title: '玩家反馈',
  //     keepAlive: false
  //   }
  // },
  // {
  //   path: '/gameprompt/:lang/:companyid',
  //   components:require('@/pages/gameprompt/index.vue'),
  //   meta:{
  //     title: '游戏协议提示',
  //     keepAlive: false
  //   }
  // },
  // {
  //   path: '/agreement/:lang/:companyid',
  //   components:require('@/pages/agreement/index.vue'),
  //   meta:{
  //     title: '用户协议',
  //     keepAlive: false
  //   }
  // },
  // {
  //   path: '/privacy/:lang/:companyid',
  //   components:require('@/pages/privacy/index.vue'),
  //   meta:{
  //     title: '隐私策略',
  //     keepAlive: false
  //   }
  // },
  // {
  //   path: '/charge',
  //   components:require('@/pages/charge/index.vue'),
  //   meta:{
  //     title: '充值入口',
  //     keepAlive: false
  //   }
  // },
  // {
  //   path: '/error',
  //   components:require('@/pages/charge/error.vue'),
  //   meta:{
  //     title: '错误提示',
  //     keepAlive: false
  //   }
  // },
  {
    path: '/web/firehero',
    components:require('@/pages/website/firehero/index.vue'),
    meta:{
      title: '烈火官網',
      keepAlive: false
    }
  },
  {
    path: '/web/firehero/h5',
    components: require('@/pages/website/firehero/h5.vue'),
    meta: {
      title: '烈火官網',
      keepAlive: false
    }
  }
]




export default new Router({
  routes: routes,
  strict: process.env.NODE_ENV !== "production"
})



// WEBPACK FOOTER //
// ./src/router/index.js